import React from "react";

import GodzillaLoader from '../../../../assets/images/load_godzilla.gif';

export const PageLoader = () => (
  <div className="page-loader">
    <img alt="loader" src={GodzillaLoader} width="320" height="220"/>
  </div>
);
